import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Protected({ requiredRoles, children }) {
  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);
  if (!isLoggedIn) {
    if (window.location.href.includes("/NewsDetails") == false
      && window.location.href.includes("/EventDetails") == false
      && window.location.href.includes("/AlertObservationForm") == false
      && window.location.href.includes("/IncidentSourceForm") == false
    ) {
      return <Navigate to="/" />;
    }
  }
  if (!currentUser) {
    if (window.location.href.includes("/NewsDetails") == false
      && window.location.href.includes("/EventDetails") == false
      && window.location.href.includes("/AlertObservationForm") == false
      && window.location.href.includes("/IncidentSourceForm") == false
    ) {
      return <Navigate to="/unauthorized" replace />;
    }
  }
  //const userHasRequiredRole = requiredRoles.includes(currentUser.role_en);

  // if (!userHasRequiredRole) {
  //   // Handle the case when the user doesn't have a required role
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return children;
}

export default Protected;
